<div class="d-flex align-items-center justify-content-center">
  <span
    class="spinner-border text-primary"
    style="width: 50px; height: 50px"
  ></span>
</div>
